/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Changelog_DraftInputs */

const fr_changelog_draft = /** @type {(inputs: Changelog_DraftInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Brouillon`)
};

/**

* @param {Changelog_DraftInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const changelog_draft = /** @type {((inputs?: Changelog_DraftInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Changelog_DraftInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_changelog_draft(inputs)
});